/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import Rails from 'rails-ujs'
import Turbolinks from 'turbolinks'
import React from 'react'
import ReactDOM from 'react-dom'

import 'babel-polyfill'
import {} from '../components'
import {} from '../components/PrimaryMenu'
import {} from '../interactions/errors'
import {} from '../interactions/modals'
import {} from '../interactions/nav'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://347a27410f4f4239a709a257f6abd80b@o544986.ingest.sentry.io/6753702',
    integrations: [new Integrations.BrowserTracing()],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.5
  })
}

Rails.start()
Turbolinks.start()
